
/**
 *  カテゴリ選択コンポーネント
 */
export default {
    template: '#category_filter_template',
    data() {
        return {
            // 選択済みカテゴリー
            selectedCategory: null,
            // カテゴリセレクトボックスオプション
            options: [],
        };
    },
    props: {
        // カテゴリー一覧
        categories: {
            type: Array,
            required: false,
            default: null,
        },
    },
    watch: {
        categories(value) {
            this.makeCategoryOptions(value);
        },
        selectedCategory() {
            this.emitSelectedCategory();
        }
    },
    emits: ['seleceted-category'],
    methods: {
        // カテゴリ一覧をもとにセレクトボックスオプションを生成する
        makeCategoryOptions: function (categories) {
            this.options = [];
            for (let i = 0; i < categories.length; i++) {
                var option = { text: this.getOptionText(categories[i]), value: categories[i].page_key };
                this.options.push(option);
            }
        },
        // オプションテキストを取得する
        getOptionText: function (category, children = null) {
            var optionText = (children !== null) ? (category.name + ' / ' +  children) : category.name;
            if(category.parent_page_key === null) {
                return optionText;
            } else {
                for (let i = 0; i < this.categories.length; i++) {
                    if(this.categories[i].page_key === category.parent_page_key) {
                        return this.getOptionText(this.categories[i], optionText);
                    }
                }
            }
        },
        // 指定カテゴリを選択状態にする
        setCategory: function (pageKey) {
            const setOption = this.options.filter(function(option) {
                return option.value === pageKey;
            });
            if (setOption.length) {
                this.selectedCategory = setOption[0].value;
            }
        },
        // カテゴリの最初の要素(hiddenカテゴリを除く)を選択状態にする
        selectFirstCategory: function () {
            // hidden以外の要素がない場合何もしない
            if(this.options.length < 2) {
                return;
            }
            this.selectedCategory = this.options[1].value;
        },
        // 更新を親に通知
        emitSelectedCategory: function () {
            this.$emit('seleceted-category', this.selectedCategory);
        }
    }
};
